<script setup lang="ts">
import type { AppTextareaEvent } from '@shared/ui/fields'

import { AppTextarea } from '@shared/ui/fields'
import { BtnPrimary, BtnSecondary } from '@shared/ui/buttons'

import { useKanbanCommentForm } from '../../model/comment/comment-form.hook'

defineOptions({
  name: 'KanbanCommentForm',
})

defineProps<KanbanCommentFormProps>()

const emit = defineEmits<{
  'input:comment': [AppTextareaEvent]
  'click:submit': []
  'click:cancel': []
}>()

interface KanbanCommentFormProps {
  label: string
  comment: string
  disabled: boolean
}

const {
  handleInputComment,
  handleClickSubmit,
  handleClickCancel,
} = useKanbanCommentForm({
  onInputComment: (event: AppTextareaEvent) => emit('input:comment', event),
  onSubmit: () => emit('click:submit'),
  onCancel: () => emit('click:cancel'),
})
</script>

<template>
  <div class="kanban-comment-form">
    <AppTextarea
      :label="label"
      :value="comment"
      placeholder="Type here"
      @input="handleInputComment"
    />
    <div class="kanban-comment-form__controls">
      <BtnPrimary
        :text="label"
        :disabled="disabled"
        @click="handleClickSubmit"
      />
      <BtnSecondary
        text="Cancel"
        @click="handleClickCancel"
      />
    </div>
  </div>
</template>

<style scoped lang="scss" src="./KanbanCommentForm.scss" />
